import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.5 3L14.5 9.5L7.5 16", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgArrowRight);
export default ForwardRef;
